<template>
  <LazyBlogPageLayout hydrate-on-idle path="public-offer" />
</template>
